import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { countReviewVentureStatuses, isReviewRequestFullyApproved, isReviewVentureOpenForReview, usePortfolioReviewContext } from '~/functions/review';
import { renderSafeMarkdown } from '~/functions/markdown';
import { useGetReviewRequestQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var route = useRoute();
    var router = useRouter();
    var requestId = computed(function () {
      return route.params.requestId;
    });
    var _usePortfolioReviewCo = usePortfolioReviewContext(),
      hasReviewerRole = _usePortfolioReviewCo.hasReviewerRole;
    var eventsTableRef = ref(null);
    var _useGetReviewRequestQ = useGetReviewRequestQuery(computed(function () {
        return {
          id: requestId.value
        };
      }), computed(function () {
        return {
          enabled: hasReviewerRole.value && !!requestId.value,
          fetchPolicy: 'cache-and-network'
        };
      })),
      result = _useGetReviewRequestQ.result,
      loading = _useGetReviewRequestQ.loading,
      refetchReviewRequest = _useGetReviewRequestQ.refetch;
    var refreshReviewData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _eventsTableRef$value;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([refetchReviewRequest(), (_eventsTableRef$value = eventsTableRef.value) === null || _eventsTableRef$value === void 0 ? void 0 : _eventsTableRef$value.refetch()]);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function refreshReviewData() {
        return _ref2.apply(this, arguments);
      };
    }();
    onActivated(function () {
      if (hasReviewerRole.value && requestId.value) {
        refreshReviewData();
      }
    });
    var request = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getReviewRequest;
    });
    var renderedDescription = computed(function () {
      var _request$value;
      return (_request$value = request.value) !== null && _request$value !== void 0 && _request$value.description ? renderSafeMarkdown(request.value.description) : '';
    });
    var ventureStatusCounts = computed(function () {
      var _request$value2;
      return countReviewVentureStatuses((_request$value2 = request.value) === null || _request$value2 === void 0 ? void 0 : _request$value2.ventures);
    });
    var isReviewComplete = computed(function () {
      var _request$value3;
      return isReviewRequestFullyApproved((_request$value3 = request.value) === null || _request$value3 === void 0 ? void 0 : _request$value3.ventures);
    });
    var statusSortOrder = {
      AWAITING_REVIEW: 0,
      EDITS_REQUESTED: 1,
      APPROVED: 2
    };
    var ventureStatus = function ventureStatus(venture) {
      return venture.status || 'AWAITING_REVIEW';
    };
    var isAwaitingVenture = function isAwaitingVenture(venture) {
      return isReviewVentureOpenForReview(venture.status);
    };
    var isDoneVenture = function isDoneVenture(venture) {
      return ventureStatus(venture) === 'APPROVED';
    };
    var sortVentures = function sortVentures(ventures) {
      return _toConsumableArray(ventures).sort(function (a, b) {
        var _statusSortOrder$vent, _statusSortOrder$vent2, _a$venture$name, _a$venture, _b$venture$name, _b$venture;
        var aOrder = (_statusSortOrder$vent = statusSortOrder[ventureStatus(a)]) !== null && _statusSortOrder$vent !== void 0 ? _statusSortOrder$vent : 0;
        var bOrder = (_statusSortOrder$vent2 = statusSortOrder[ventureStatus(b)]) !== null && _statusSortOrder$vent2 !== void 0 ? _statusSortOrder$vent2 : 0;
        if (aOrder !== bOrder) {
          return aOrder - bOrder;
        }
        return ((_a$venture$name = (_a$venture = a.venture) === null || _a$venture === void 0 ? void 0 : _a$venture.name) !== null && _a$venture$name !== void 0 ? _a$venture$name : '').localeCompare((_b$venture$name = (_b$venture = b.venture) === null || _b$venture === void 0 ? void 0 : _b$venture.name) !== null && _b$venture$name !== void 0 ? _b$venture$name : '');
      });
    };
    var sortedVentures = computed(function () {
      var _request$value$ventur, _request$value4;
      return sortVentures((_request$value$ventur = (_request$value4 = request.value) === null || _request$value4 === void 0 ? void 0 : _request$value4.ventures) !== null && _request$value$ventur !== void 0 ? _request$value$ventur : []);
    });
    var batchSubmitVentureRows = computed(function () {
      return sortedVentures.value.map(function (venture) {
        var _venture$venture;
        return {
          ventureId: venture.ventureId,
          name: ((_venture$venture = venture.venture) === null || _venture$venture === void 0 ? void 0 : _venture$venture.name) || venture.ventureId,
          status: venture.status || 'AWAITING_REVIEW'
        };
      });
    });
    var statusFilter = ref('all');
    var showBatchSubmitDialog = ref(false);
    var filterCounts = computed(function () {
      var ventures = sortedVentures.value;
      return {
        all: ventures.length,
        awaiting: ventures.filter(isAwaitingVenture).length,
        done: ventures.filter(isDoneVenture).length
      };
    });
    var filteredVentures = computed(function () {
      var ventures = sortedVentures.value;
      if (statusFilter.value === 'awaiting') {
        return ventures.filter(isAwaitingVenture);
      }
      if (statusFilter.value === 'done') {
        return ventures.filter(isDoneVenture);
      }
      return ventures;
    });
    watch(loading, function (isLoading) {
      if (!isLoading && !request.value && hasReviewerRole.value) {
        router.replace({
          name: 'portfolio-review'
        });
      }
    });
    var companyHeaders = computed(function () {
      return [{
        text: proxy.$t('company'),
        value: 'venture.name',
        class: 'review-table-th'
      }, {
        text: proxy.$t('status'),
        value: 'status',
        class: 'review-table-th',
        width: '160px'
      }, {
        text: proxy.$t('lastReviewer'),
        value: 'latestEvent.reviewer',
        class: 'review-table-th'
      }, {
        text: proxy.$t('reviewedAt'),
        value: 'latestEvent.createdAt',
        class: 'review-table-th',
        width: '180px'
      }, {
        text: '',
        value: 'actions',
        sortable: false,
        align: 'end',
        class: 'review-table-th',
        width: '56px'
      }];
    });
    var formatDate = function formatDate(value) {
      if (!value) {
        return '—';
      }
      return new Date(value).toLocaleString();
    };
    var openBatchSubmitDialog = function openBatchSubmitDialog() {
      showBatchSubmitDialog.value = true;
    };
    var onBatchSubmitDialogInput = function onBatchSubmitDialogInput(open) {
      showBatchSubmitDialog.value = open;
    };
    var goToCompany = function goToCompany(_e, _ref3) {
      var item = _ref3.item;
      router.push("/portfolio/review/".concat(requestId.value, "/company/").concat(item.ventureId));
    };
    var goToCompanyRow = function goToCompanyRow(item) {
      router.push("/portfolio/review/".concat(requestId.value, "/company/").concat(item.ventureId));
    };
    return {
      __sfc: true,
      proxy: proxy,
      route: route,
      router: router,
      requestId: requestId,
      hasReviewerRole: hasReviewerRole,
      eventsTableRef: eventsTableRef,
      result: result,
      loading: loading,
      refetchReviewRequest: refetchReviewRequest,
      refreshReviewData: refreshReviewData,
      request: request,
      renderedDescription: renderedDescription,
      ventureStatusCounts: ventureStatusCounts,
      isReviewComplete: isReviewComplete,
      statusSortOrder: statusSortOrder,
      ventureStatus: ventureStatus,
      isAwaitingVenture: isAwaitingVenture,
      isDoneVenture: isDoneVenture,
      sortVentures: sortVentures,
      sortedVentures: sortedVentures,
      batchSubmitVentureRows: batchSubmitVentureRows,
      statusFilter: statusFilter,
      showBatchSubmitDialog: showBatchSubmitDialog,
      filterCounts: filterCounts,
      filteredVentures: filteredVentures,
      companyHeaders: companyHeaders,
      formatDate: formatDate,
      openBatchSubmitDialog: openBatchSubmitDialog,
      onBatchSubmitDialogInput: onBatchSubmitDialogInput,
      goToCompany: goToCompany,
      goToCompanyRow: goToCompanyRow
    };
  }
});